import { gql } from '@apollo/client';

const GET_READ_STORY = gql`
  query getReadStory($readActivityWhere: ReadActivityWhereInput!) {
    readStory(where: $readActivityWhere) {
      book {
        id
        bookCode
        type
        characters {
          id
          character
          characterCase
          characterType
        }
        path
        offset
      }
      pages {
        words {
          id
          description
          src
        }
        page {
          id
          pageNumber
          src
        }
      }
    }
  }
`;

export default GET_READ_STORY;
